import initialState from './../initialState';

const reducers = {
  LOAD_ESTABLISHMENTS_SUCCESS: (state, payload) => {
    return payload;
  },
  CREATE_ESTABLISHMENT_SUCCESS: (state, payload) => {
    let newState =  [
      ...state.filter(establishment => establishment.id !== payload.id)
    ];
    newState.splice(0,0, Object.assign({}, payload));
    return newState;
  },
  EDIT_ESTABLISHMENT_SUCCESS: (state, payload) => {
    let newState =  [
      ...state.filter(establishment => establishment.id !== payload.id)
    ];
    newState.splice(0,0, Object.assign({}, payload));
    return newState;
  },
  REMOVE_ESTABLISHMENT_SUCCESS:(state, payload)=>{
    let newState =  [
      ...state.filter(establishment => establishment.id !== payload.id)
    ];
    newState.splice(0,0, Object.assign({}, payload, {establishment_status: 2}));
    return newState;
  },
  LOGOUT_ESTABLISHMENT:() => {
    return [];
  }
};

export default function establishments(state = initialState.establishments, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action.establishments) : state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/establishment/establishmentReducer.js
 **/